const isEmployeeOfOrg = (employees, orgProviderId) => employees.map((e) => e.provider.id).includes(orgProviderId);

export default isEmployeeOfOrg;
